module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<li role="presentation" id="nav' +
((__t = ( data.id )) == null ? '' : __t) +
'" class="tab-navi ' +
((__t = ( data.tooltip ? 'tooltipped tooltipped-n' : '' )) == null ? '' : __t) +
' ' +
((__t = ( data.hideCloseIcon ? 'no-close-icon' : 'has-close-icon' )) == null ? '' : __t) +
'" aria-label="' +
__e( data.tooltip ) +
'">\n    ';
 if (data.icon) { ;
__p += '<i class="' +
((__t = (data.icon)) == null ? '' : __t) +
' leftIcon"></i>';
 } ;
__p += '\n    <a href="#' +
((__t = ( data.id )) == null ? '' : __t) +
'" class="tab-nav-name ' +
((__t = (data.icon ? 'hasLeftIcon' : '')) == null ? '' : __t) +
'" aria-controls="' +
((__t = ( data.id )) == null ? '' : __t) +
'" role="tab" data-toggle="tab">' +
((__t = ( data.name )) == null ? '' : __t) +
'</a>\n    ';
 if (!data.hideCloseIcon) { ;
__p += '\n        <i class="far fa-times closeTab" data-close="' +
((__t = ( data.id )) == null ? '' : __t) +
'" title="Close"></i>\n    ';
 } ;
__p += '\n</li>\n\n';
return __p
}